module.exports = __webpack_public_path__ + "img/build1030.a00413a7.png";